import { Link } from "react-router-dom";

interface TripsEmptyProps {
  title: string;
  message: string;
  icon: string;
  actionLabel?: string;
  to?: string;
}

export default function TripsEmpty({ title, message, icon, actionLabel, to }: TripsEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-background-200 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200/60 text-3xl text-foreground-500">
        <i className={icon}></i>
      </span>
      <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-sm text-sm text-foreground-600">{message}</p>
      {actionLabel && to && (
        <Link
          to={to}
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-search-eye-line"></i> {actionLabel}
        </Link>
      )}
    </div>
  );
}